import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "../../style";
import SeeMore from "../../../shared/SeeMore";
import { useNewOfferMobile } from "../../../context";
import SelectForm from "../../../../../../shared/atoms/SelectForm";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const yearsOptions = new Array(15).fill().map((it, idx) => {
	let year = idx + currentYear;
	return { value: year, label: year };
});
const monthOptions = [
	{ label: "Jan", value: 1 },
	{ label: "Fev", value: 2 },
	{ label: "Mar", value: 3 },
	{ label: "Abr", value: 4 },
	{ label: "Mai", value: 5 },
	{ label: "Jun", value: 6 },
	{ label: "Jul", value: 7 },
	{ label: "Ago", value: 8 },
	{ label: "Set", value: 9 },
	{ label: "Out", value: 10 },
	{ label: "Nov", value: 11 },
	{ label: "Dez", value: 12 }
];

const CreditCardValidateInput = ({ step, creditCardData, onChangeCreditCardData }) => {
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		expirationMonth: creditCardData.data.expirationMonth || "",
		expirationYear: creditCardData.data.expirationYear || "",
		errors: {
			expirationMonth: false,
			expirationYear: false
		}
	});

	useEffect(() => {
		setStepError(!state.expirationMonth.length || !state.expirationYear.length);
	}, [state]);

	const onChange = event => {
		const { name, value } = event.target;

		switch (name) {
			case "expirationMonth":
				setState({
					...state,
					[name]: value,
					errors: {
						[name]: !value.length || (currentYear == expirationYear && value < currentMonth)
					}
				});
				onChangeCreditCardData({ [name]: value });
				break;
			case "expirationYear":
				setState({
					...state,
					[name]: value,
					errors: {
						expirationMonth:
							!value.length || (currentYear == value && expirationMonth < currentMonth)
					}
				});
				onChangeCreditCardData({ [name]: value });
				break;
		}
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados do cartão
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<div className="row">
					<div className="col-xs-8 col-md-4">
						<SelectForm
							name="expirationMonth"
							options={monthOptions}
							value={state.expirationMonth}
							onChange={onChange}
							defaultOption="Mês"
							label="Validade"
							errorMessage="Data inválida"
							hasError={state.errors.expirationMonth}
							data-action="register-credit-card-valid-month"
						/>
					</div>
					<div className="col-xs-8 col-md-4">
						<SelectForm
							name="expirationYear"
							options={yearsOptions}
							value={state.expirationYear}
							onChange={onChange}
							defaultOption="Ano"
							label={"\u00A0"}
							errorMessage={state.errors.expirationMonth ? "" : "Data inválida"}
							hasError={state.errors.expirationYear}
							data-action="register-credit-card-valid-year"
						/>
					</div>
				</div>
			</div>

			<SeeMore>
				<strong>Por que precisamos dos dados do seu cartão?</strong>
				<p>
					Para emitir passagens em companhias internacionais, o pagamento das taxas e encargos deve
					ser feito no cartão de crédito do mesmo titular das milhas.                 
				</p>

				<p>Por isso, cadastre os dados corretos do cartão.</p>

				<p>
					<strong>Sigilo e segurança dos seus dados</strong>
				</p>

				<p>
					Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
					segurança. Aqui, seus dados estão protegidos.
				</p>
			</SeeMore>
		</div>
	);
};

export default CreditCardValidateInput;
